// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"46dcb025","977":"ed5dca5f"}[chunkId] + ".chunk.js";
};